// src/components/Contact.js
import React from 'react';
import '../css/Contact.css'; // Make sure this path is correct

import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaMobileAlt, FaSearch, FaPhoneAlt } from 'react-icons/fa';

export default function Contact() {

    // Function to handle WhatsApp submission for the main contact form
    const handleWhatsAppSubmit = (event) => {
        event.preventDefault(); // Prevent default form submission behavior

        // Get form input values
        const name = document.getElementById('name').value;
        const email = document.getElementById('email').value;
        const phone = document.getElementById('phone').value;
        const message = document.getElementById('message').value;

        // Construct the WhatsApp message text with bolding
        let whatsappMessage = `*Hello, I'd like to inquire about PG accommodations.*\n\n`; // Bolded intro sentence
        whatsappMessage += `*Name:* ${name}\n`; // Bolded 'Name:'
        whatsappMessage += `*Email:* ${email}\n`; // Bolded 'Email:'
        whatsappMessage += `*Phone:* ${phone}\n`; // Bolded 'Phone:'
        whatsappMessage += `*Message:* ${message}`; // Bolded 'Message:'

        // Encode the message for URL
        const encodedMessage = encodeURIComponent(whatsappMessage);

        // WhatsApp number (using one of the numbers from your contact info)
        const whatsappNumber = '918879779777'; // Replace with the actual WhatsApp number

        // Construct the WhatsApp URL
        const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;

        // Open WhatsApp in a new tab
        window.open(whatsappUrl, '_blank');
    };

    // Function to handle WhatsApp submission for the search query
    const handleSearchWhatsAppSubmit = (event) => {
        event.preventDefault(); // Prevent default button behavior

        const accommodationType = document.getElementById('accommodationType').value;
        const sharingType = document.getElementById('sharingType').value;
        const location = document.getElementById('location').value;
        const searchArea = document.getElementById('searchArea').value;

        // Construct the WhatsApp message text for the search query
        let whatsappMessage = `*Inquiry from Filter Bar:*\n\n`;
        whatsappMessage += `*Accommodation Type:* ${accommodationType}\n`;
        whatsappMessage += `*Sharing Type:* ${sharingType}\n`;
        whatsappMessage += `*Location:* ${location}\n`;
        whatsappMessage += `*Search Area:* ${searchArea || 'Not specified'}\n\n`;
        whatsappMessage += `Please assist me with finding suitable accommodation.`;

        const encodedMessage = encodeURIComponent(whatsappMessage);
        const whatsappNumber = '918879779777'; // Use the same WhatsApp number
        const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;

        window.open(whatsappUrl, '_blank');
    };
    
    return (
        <div className="contact-wrapper">
            {/* Hero Background */}
            <div className="contact-banner">
                <h1>Contact Us</h1>
                <p>We'd love to hear from you!</p>
            </div>

            {/* Filter Bar */}
            <div className="contact-filters-container">
  <div className="contact-filters">
    {/* Accommodation Type Dropdown */}
    <div className="filter-group">
      <label htmlFor="accommodationType" className="filter-label">Accommodation Type</label>
      <select id="accommodationType" className="filter-select" required defaultValue="">
        <option value="" disabled>Select Accommodation Type</option>
        <option value="Co-living">Co-living</option>
        <option value="Hostel">Hostel</option>
        <option value="Apartment">Apartment</option>
      </select>
    </div>

    {/* Sharing Type Dropdown */}
    <div className="filter-group">
      <label htmlFor="sharingType" className="filter-label">Sharing Type</label>
      <select id="sharingType" className="filter-select" required defaultValue="">
        <option value="" disabled>Select Sharing Type</option>
        <option value="All Types">All Types</option>
        <option value="Single Room">Single Room</option>
        <option value="Double Sharing">Double Sharing</option>
        <option value="Triple Sharing">Triple Sharing</option>
      </select>
    </div>

    {/* Location Dropdown */}
    <div className="filter-group">
      <label htmlFor="location" className="filter-label">Location</label>
      <select id="location" className="filter-select" required defaultValue="">
        <option value="" disabled>Select Location</option>
        <option value="All Locations">All Locations</option>
        <option value="Mumbai">Mumbai</option>
        <option value="Andheri">Andheri</option>
        <option value="Bandra">Bandra</option>
        <option value="Powai">Powai</option>
        <option value="Dadar">Dadar</option>
        <option value="Worli">Worli</option>
        <option value="Malad">Malad</option>
        <option value="Borivali">Borivali</option>
        <option value="Navi Mumbai">Navi Mumbai</option>
        <option value="Thane">Thane</option>
        <option value="South Mumbai">South Mumbai</option>
      </select>
    </div>

    {/* Search Area Text Input */}
    <div className="filter-group">
      <label htmlFor="searchArea" className="filter-label">Search Area</label>
      <input
        type="text"
        id="searchArea"
        placeholder="Search by area or landmark"
        className="filter-select"
        required
      />
    </div>

    {/* Search Button */}
    <button
      type="submit"
      className="search-btn"
      onClick={handleSearchWhatsAppSubmit}
    >
      Submit
    </button>
  </div>
</div>


            {/* Main Content: Form + Info */}
            <div className="contact-main">
                <div className="contact-form-section">
  <h2>Send us a Message</h2>
  <form className="contact-form">
  <div className="form-group">
    <label htmlFor="name">Your Name</label>
    <input type="text" id="name" placeholder="Name" required />
  </div>
  <div className="form-group">
    <label htmlFor="email">Your Email</label>
    <input type="email" id="email" placeholder="@" required />
  </div>
  <div className="form-group">
    <label htmlFor="phone">Phone Number</label>
    <input type="tel" id="phone" placeholder="Phone" required />
  </div>
  <div className="form-group">
    <label htmlFor="message">Your Message</label>
    <textarea id="message" rows="6" placeholder="Tell us how we can help..." required />
  </div>

  <button
    type="button"
    className="submit-btn"
    onClick={() => {
      const name = document.getElementById("name").value.trim();
      const email = document.getElementById("email").value.trim();
      const phone = document.getElementById("phone").value.trim();
      const message = document.getElementById("message").value.trim();

      if (!name || !email || !phone || !message) {
        alert("Please fill in all required fields.");
        return;
      }

      const subject = `Message from ${name}`;
      const body = `Hi,%0D%0A%0D%0AMy name is ${name}.%0D%0AEmail: ${email}%0D%0APhone: ${phone}%0D%0A%0D%0AMessage: ${message}%0D%0A%0D%0AThanks!`;

      const mailtoLink = `mailto:swetarita25786@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

      window.location.href = mailtoLink;
    }}
  >
    Submit
  </button>
</form>

</div>


                <div className="contact-info-section">
                    <h2>Our Contact Details</h2>
                    <div className="contact-info">
                        {/* Phone numbers as tel: links with hover effects */}
                        <p>
                            <FaPhoneAlt className="info-icon" />
                            <a href="tel:+918879779777">
                                <span className="contact-label">Phone:</span> +91 887-9779-777
                            </a>
                        </p>
                        <p>
                            <FaMobileAlt className="info-icon" />
                            <a href="tel:+919820779777">
                                <span className="contact-label">Mobile:</span> +91 982-0779-777
                            </a>
                        </p>
                        {/* Email as mailto: link with hover effects */}
                        <p>
                            <FaEnvelope className="info-icon" />
                            <a href="mailto:swetarita25786@gmail.com">
                                <span className="contact-label">Email:</span> swetarita25786@gmail.com
                            </a>
                        </p>
                        {/* Address as a Google Maps link with hover effects */}
                        <p>
                            <FaMapMarkerAlt className="info-icon" />
                            <a
                                href="https://maps.app.goo.gl/7wLJNZ2rJWTEdU1r5"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <span className="contact-label">Address:</span>Pandit Soliciter Road,Opposite Blue Diamond, Malad East Mumbai - 400097
                            </a>
                        </p>
                    </div>
                    <div className="map-placeholder">
                        {/* Google Maps Embed (keep the iframe as before) */}
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3768.2380773977384!2d72.8515025!3d19.1848011!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b78e8c770c59%3A0x115b3c0861620039!2sNo%20Brokerage%20Paying%20Guest%20%7C%20Brokerage%20Free%20Girls%20Paying%20Guest%20In%20Malad%20Mumbai!5e0!3m2!1sen!2sin!4v1764831163802!5m2!1sen!2sin"
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="No Brokerage PG Map"
                        ></iframe>
                    </div>
                </div>
            </div>
        </div>
    );
}